import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getBlogListing = createAsyncThunk(
  "blogListing/getBlogListing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/blog/get_all_data`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        {}
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const blogListingSlice = createSlice({
  name: "blogListing",
  initialState: {
    loading: false,
    blogListingData: null,
    error: null,
  },
  reducers: {
    ResetBlogListingState: (state) => {
      state.loading = false;
      state.blogListingData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBlogListing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBlogListing.fulfilled, (state, action) => {
        state.loading = false;
        state.blogListingData = action.payload;
      })
      .addCase(getBlogListing.rejected, (state, action) => {
        state.loading = false;
        state.blogListingData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetBlogListingState } = blogListingSlice.actions;
export default blogListingSlice.reducer;
